import api from '@/api/axiosApi'
import type {
  WaveBreaksFullResponse,
  CreateWaveBreaksRequest,
  UpdateWaveBreaksRequest,
} from '@/components/PlanDetail/PlanWavesDrawer/types'

export async function fetchWaveBreaks(
  planId: string,
  versionId: string,
  lineId: string
): Promise<WaveBreaksFullResponse> {
  const response = await api.get<WaveBreaksFullResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/wave-breaks`
  )
  return response.data
}

export async function createWaveBreaks(
  planId: string,
  versionId: string,
  lineId: string,
  body: CreateWaveBreaksRequest
): Promise<WaveBreaksFullResponse> {
  const response = await api.post<WaveBreaksFullResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/wave-breaks`,
    body
  )
  return response.data
}

export async function updateWaveBreaks(
  planId: string,
  versionId: string,
  lineId: string,
  body: UpdateWaveBreaksRequest
): Promise<WaveBreaksFullResponse> {
  const response = await api.put<WaveBreaksFullResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/wave-breaks`,
    body
  )
  return response.data
}

export async function deleteWaveBreaks(
  planId: string,
  versionId: string,
  lineId: string
): Promise<void> {
  await api.delete(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/wave-breaks`
  )
}
